define.alias("ember-cli-string-helpers/helpers/truncate", "calendar/helpers/truncate");